import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../i18n/LanguageContext';

const TONES = {
  active: { badge: 'tw-bg-emerald-500/10 tw-text-emerald-700 dark:tw-text-emerald-300', dot: 'tw-bg-emerald-500' },
  passive: { badge: 'tw-bg-slate-500/10 tw-text-slate-600 dark:tw-text-slate-300', dot: 'tw-bg-slate-400' },
  left: { badge: 'tw-bg-amber-500/10 tw-text-amber-700 dark:tw-text-amber-300', dot: 'tw-bg-amber-500' },
};

/** Aktif / Pasif / Ayrıldı rozeti (bir çalışanın ya da bir merkezdeki atamasının durumu). */
const WorkerStatusBadge = ({ status, label }) => {
  const { t } = useTranslation();
  const tone = TONES[status] || TONES.active;
  return (
    <span className={`tw-inline-flex tw-max-w-full tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold ${tone.badge}`}>
      <span aria-hidden="true" className={`tw-h-1.5 tw-w-1.5 tw-shrink-0 tw-rounded-full ${tone.dot}`} />
      <span className="tw-truncate">{label || t(`projectManagement.workers.status.${status}`)}</span>
    </span>
  );
};

WorkerStatusBadge.propTypes = {
  status: PropTypes.oneOf(['active', 'passive', 'left']).isRequired,
  label: PropTypes.string,
};

export default WorkerStatusBadge;
